document.addEventListener('DOMContentLoaded', () => {
    const form           = document.getElementById('253211730765049') || document.querySelector('.jotform-form');
    const errorsBox      = document.querySelector('.js-form-errors');
    const reasonSelect   = document.getElementById('input_3');
    const otherWrapper   = document.querySelector('[data-other-reason]');
    const otherTextarea  = document.getElementById('input_4');
    const firstNameInput = document.getElementById('first_5');
    const lastNameInput  = document.getElementById('last_5');
    const emailInput     = document.getElementById('input_6');
    const messageInput   = document.getElementById('input_7');
    const submitButton   = document.querySelector('.contact-submit-btn');


    /* toggle "Other reason" field */
    const toggleOtherField = () => {
        const isOther = reasonSelect && reasonSelect.value === 'other';
        if (otherWrapper) { 
            otherWrapper.classList.toggle('always-hidden', !isOther);
            otherWrapper.classList.toggle('hidden', !isOther);
        }
    };
    if (reasonSelect) {
        toggleOtherField();
        reasonSelect.addEventListener('change', toggleOtherField);
    }

    /* email regex */
    const isValidEmail = (value) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

    /* Validation on submit */
    if (!submitButton || !form) {
        return; // Exit if required elements are missing
    }

    submitButton.addEventListener('click', (e) => {

        let errors = [];

        // clear previous states
        if (errorsBox) {
            errorsBox.innerHTML = '';
        }
        if (form) {
            form.querySelectorAll('.input-error').forEach(el => el.classList.remove('input-error'));
        }

        if (reasonSelect && !reasonSelect.value) {
            errors.push({field: reasonSelect, msg: 'Please choose a reason for contacting.'});
        }

        /* If "Other" selected, textarea must not be blank */
        if (reasonSelect && reasonSelect.value === 'other' && otherTextarea && !otherTextarea.value.trim()) {
            errors.push({field: otherTextarea, msg: 'Please specify your reason.'});
        }

        if (firstNameInput && !firstNameInput.value.trim()) {
            errors.push({field: firstNameInput, msg: 'First name is required.'});
        }

        if (lastNameInput && !lastNameInput.value.trim()) {
            errors.push({field: lastNameInput, msg: 'Last name is required.'});
        }

        if (emailInput && !emailInput.value.trim()) {
            errors.push({field: emailInput, msg: 'Email is required.'});
        } else if (emailInput && !isValidEmail(emailInput.value)) {
            errors.push({field: emailInput, msg: 'Enter a valid email.'});
        }

        if (messageInput && !messageInput.value.trim()) {
            errors.push({field: messageInput, msg: 'Message cannot be blank.'});
        }

        /* show errors if any */
        if (errors.length) {
            e.preventDefault();
            if (errorsBox) {
                errorsBox.innerHTML = '';
                errors.forEach(({field, msg}) => {
                    field.classList.add('input-error');
                    const li = document.createElement('li');
                    li.textContent = msg;
                    errorsBox.appendChild(li);
                });
            }
            if (errors[0] && errors[0].field) {
                errors[0].field.focus();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            // Allow form to submit normally (JotForm will handle submission)
        }
    });
});